import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { pushTokenStatusCacheKey } from "./constants";
import type { PushTokenStatusPayload } from "./types";

export const pushTokenStatus = reactQueryFetcherAdapter(
  pushTokenStatusCacheKey,
  async (signal, userIdentifier: string, token: string): Promise<PushTokenStatusPayload> => {
    return fetch<PushTokenStatusPayload>(
      `/apps/user_info/${userIdentifier}/push_token_status`,
      "GET",
      { token },
      { signal }
    );
  }
);
